namespace GeniuzPOS.Inventory {
    export interface IcStockEomProcessingForm {
        MonthProcess: Serenity.LookupEditor;
        YearProcess: Serenity.DateYearEditor;
        PostFg: Serenity.EnumEditor;
        PostSequenceFg: Serenity.EnumEditor;
        UseFg: Serenity.RadioButtonEditor;
        LastMonthEomId: Serenity.IntegerEditor;
    }

    export class IcStockEomProcessingForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockEomProcessing';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockEomProcessingForm.init)  {
                IcStockEomProcessingForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DateYearEditor;
                var w2 = s.EnumEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = s.IntegerEditor;

                Q.initFormType(IcStockEomProcessingForm, [
                    'MonthProcess', w0,
                    'YearProcess', w1,
                    'PostFg', w2,
                    'PostSequenceFg', w2,
                    'UseFg', w3,
                    'LastMonthEomId', w4
                ]);
            }
        }
    }
}
